import { PropsWithChildren } from 'react';
import { setContext } from '@apollo/client/link/context';
import { ApolloClient, ApolloProvider, createHttpLink, DefaultOptions, InMemoryCache } from '@apollo/client';


import { getAccessToken } from '../../services/token';
import config from '../../utils/config';

const httpLink = createHttpLink({
    uri: config.graphqlBaseUrl,
});

const authLink = setContext((_, { headers }) => {
    // get the authentication token from local storage if it exists
    const token = getAccessToken();
    // return the headers to the context so httpLink can read them
    return {
        headers: {
            ...headers,
            token: token || "",
        }
    }
});

const defaultOptions: DefaultOptions = {
    watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'ignore',
    },
    query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
    },
}

export const client = new ApolloClient({
    link: authLink.concat(httpLink),
    uri: config.graphqlBaseUrl,
    cache: new InMemoryCache(),
    defaultOptions: defaultOptions,
});

const GraphQLProvider = (props: PropsWithChildren) => {
    const { children } = props;

    return (
        <ApolloProvider client={client}>
            {children}
        </ApolloProvider>
    )
}

export default GraphQLProvider